import { MessageCircle } from "lucide-react";
import { BRAND } from "@/lib/brand";
import { useEffect, useState } from "react";

export const WhatsAppFAB = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={BRAND.whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar no WhatsApp com Imporparts"
      data-testid="whatsapp-fab"
      className={`fixed bottom-6 right-6 z-50 group transition-all duration-300 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <div className="flex items-center gap-3 pl-4 pr-2 py-2 rounded-full bg-white shadow-2xl border border-slate-200 hover:border-emerald-300 transition-colors">
        <div className="hidden md:block">
          <div className="text-[10px] tracking-[0.2em] uppercase font-semibold text-slate-400 leading-none">
            Fale agora
          </div>
          <div className="text-sm font-semibold text-navy leading-tight mt-0.5">
            Solicite sua cotação
          </div>
        </div>
        <div
          className="w-12 h-12 rounded-full flex items-center justify-center wa-pulse"
          style={{ background: "#25D366" }}
        >
          <MessageCircle className="w-6 h-6 text-white" />
        </div>
      </div>
    </a>
  );
};
